import React from 'react';

export const SubjectIcon = ({ subject, className = "w-6 h-6" }) => {
    const s = (subject || '').toLowerCase();
    
    let path;
    let idSuffix = 'default';
    let langCode = null;

    if (s.includes('math')) {
        // Calculatrice
        path = (
            <>
                <rect width="16" height="20" x="4" y="2" rx="2" />
                <rect width="10" height="4" x="7" y="6" rx="1" />
                <line x1="8" y1="13" x2="10" y2="13" />
                <line x1="14" y1="12" x2="14" y2="14" /><line x1="13" y1="13" x2="15" y2="13" />
                <line x1="8" y1="17" x2="10" y2="17" /><line x1="8" y1="18" x2="10" y2="18" />
                <line x1="13" y1="17" x2="15" y2="19" /><line x1="15" y1="17" x2="13" y2="19" />
            </>
        );
        idSuffix = 'math';
    } else if (s.includes('physique') || s.includes('chimie')) {
        // Atome (Orbites croisées)
        path = (
            <>
                <circle cx="12" cy="12" r="2" />
                <ellipse cx="12" cy="12" rx="10" ry="3.5" transform="rotate(45 12 12)" />
                <ellipse cx="12" cy="12" rx="10" ry="3.5" transform="rotate(-45 12 12)" />
            </>
        );
        idSuffix = 'phys';
    } else if (s.includes('fran') || s.includes('lettre')) {
        // Plume / Stylo
        path = (
            <>
                <path d="M12 19l7-7 3 3-7 7-3-3z"/>
                <path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z"/>
                <path d="M2 2l7.586 7.586"/><circle cx="11" cy="11" r="2"/>
            </>
        );
        idSuffix = 'fran';
    } else if (s.includes('histoire') || s.includes('géo')) {
        // Globe terrestre de classe
        path = (
            <>
                <circle cx="12" cy="10" r="8"/>
                <ellipse cx="12" cy="10" rx="8" ry="3"/>
                <ellipse cx="12" cy="10" rx="3" ry="8"/>
                <line x1="12" y1="18" x2="12" y2="22"/>
                <line x1="8" y1="22" x2="16" y2="22"/>
            </>
        );
        idSuffix = 'hist';
    } else if (s.includes('anglais') || s.includes('espagnol') || s.includes('allemand') || s.includes('langue')) {
        // Bulle de discussion avec lettrage du pays
        path = <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/>;
        if (s.includes('anglais')) langCode = 'EN';
        else if (s.includes('espagnol')) langCode = 'ES';
        else if (s.includes('allemand')) langCode = 'DE';
        idSuffix = 'lang';
    } else if (s.includes('info') || s.includes('numérique') || s.includes('tech')) {
        // Ordinateur (Laptop)
        path = (
            <>
                <rect x="3" y="4" width="18" height="12" rx="1"/>
                <path d="M2 20h20l-2-4H4Z"/>
            </>
        );
        idSuffix = 'info';
    } else if (s.includes('svt') || s.includes('biologie') || s.includes('science')) {
        // Feuille
        path = (
            <>
                <path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z"/>
                <path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"/>
            </>
        );
        idSuffix = 'svt';
    } else if (s === 'toutes') {
        // Grille (Général)
        path = (
            <>
                <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/>
                <rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/>
            </>
        );
        idSuffix = 'all';
    } else {
        // Livre (Par défaut)
        path = (
            <>
                <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
                <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
            </>
        );
    }

    const gradientId = `grad-icon-${idSuffix}`;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke={`url(#${gradientId})`} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
            <defs>
                <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#06b6d4" /> {/* Cyan 500 */}
                    <stop offset="100%" stopColor="#a855f7" /> {/* Purple 500 */}
                </linearGradient>
            </defs>
            {path}
            {langCode && <text x="12" y="14.5" textAnchor="middle" fontSize="9" fontWeight="bold" stroke="none" fill={`url(#${gradientId})`} fontFamily="sans-serif">{langCode}</text>}
        </svg>
    );
};